
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { SolicitacaoFormData } from '@/types/solicitacao';

interface EditRequisicaoReadOnlyFieldsProps {
  form: UseFormReturn<SolicitacaoFormData>;
  readOnly?: boolean;
}

export const EditRequisicaoReadOnlyFields = ({ form, readOnly = false }: EditRequisicaoReadOnlyFieldsProps) => {
  return (
    <>
      {/* Título - Read-only */}
      <FormField
        control={form.control}
        name="titulo"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Título *</FormLabel>
            <FormControl>
              <Input {...field} readOnly className={readOnly ? "bg-gray-100 text-gray-600" : "bg-gray-50"} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Descrição - Read-only */}
      <FormField
        control={form.control}
        name="descricao"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Descrição</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                readOnly 
                rows={4}
                className={readOnly ? "bg-gray-100 text-gray-600 resize-none" : "bg-gray-50 resize-none"} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
